import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import axios from 'axios';
import { toast } from 'sonner';
import { Toaster } from '@/components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, formData, {
        withCredentials: true
      });
      toast.success('Connexion réussie !');
      navigate('/membre');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/membre';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Toaster />
      <Navigation />

      <section className="section-padding bg-white" data-testid="login-page">
        <div className="container mx-auto px-6">
          <div className="max-w-md mx-auto">
            <div className="text-center mb-8">
              <h1 
                className="text-4xl font-bold text-[#2E332D] mb-4"
                style={{ fontFamily: 'Cormorant Garamond, serif' }}
                data-testid="login-title"
              >
                Connexion
              </h1>
              <p className="text-[#5C665A]">
                Content de vous revoir !
              </p>
            </div>

            <div className="card">
              <form onSubmit={handleSubmit} data-testid="login-form">
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-[#2E332D] mb-2">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      data-testid="login-email-input"
                      className="w-full px-4 py-2 border border-[#E5E3DB] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4A6B48]"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#2E332D] mb-2">
                      Mot de passe
                    </label>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      required
                      data-testid="login-password-input"
                      className="w-full px-4 py-2 border border-[#E5E3DB] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4A6B48]"
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    data-testid="login-submit-button"
                    className="w-full btn-primary py-3 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {loading ? 'Connexion...' : 'Se connecter'}
                  </button>
                </div>
              </form>

              <div className="my-6 flex items-center">
                <div className="flex-1 border-t border-[#E5E3DB]"></div>
                <span className="px-4 text-sm text-[#5C665A]">ou</span>
                <div className="flex-1 border-t border-[#E5E3DB]"></div>
              </div>

              <button
                onClick={handleGoogleLogin}
                data-testid="google-login-button"
                className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-[#E5E3DB] rounded-lg hover:bg-gray-50 transition-all"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Continuer avec Google
              </button>

              <p className="mt-6 text-center text-sm text-[#5C665A]">
                Pas encore de compte ?{' '}
                <Link to="/register" className="text-[#4A6B48] font-medium hover:underline" data-testid="register-link">
                  S&apos;inscrire
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
